import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

interface IFiltersContentProps {
  maxWidth: string;
}

interface IWrapperProps {
  marginRight?: string;
}

interface IThProps {
  width: string;
  textAlign: string;
}

interface ITdProps {
  width?: string;
  textAlign?: string;
  padding?: string;
  display?: string;
  heading?: string;
}

export const Container = styled(motion.section)`
  ${({ theme }) => css`
    width: 100%;
    margin: 2.4rem 0;
    padding: 2.4rem;
    background: ${theme.colors.backgroundContainer};
    border-radius: ${theme.radius.small};
    box-shadow: ${theme.shadows.flat};
  `}
`;

export const LabelContainer = styled.div`
  margin-bottom: 0.5rem;
`;

export const Label = styled.label`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.default};
    color: ${theme.colors.labelInput};
  `}
`;

export const FiltersContent = styled.div<IFiltersContentProps>`
  ${({ maxWidth }) => css`
    width: 100%;
    display: flex;
    margin-bottom: 2rem;
    align-items: center;

    ${maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
  `}
`;

export const FiltersMainWrapper = styled.fieldset`
  ${({ theme }) => css`
    width: 75%;
    border-radius: ${theme.radius.small};
    padding: 10px;
    border: 1px solid #abaebf;
  `}
`;

export const FiltersButtonWrapper = styled.div`
  width: 25%;
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  display: flex;

  @media (max-width: 1010px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div<IWrapperProps>`
  ${({ marginRight }) => css`
    width: 100%;
    margin-bottom: 2rem;

    ${marginRight &&
    css`
      margin-right: ${marginRight};
    `}

    @media (max-width: 1010px) {
      margin: 0 0 2rem 0;
    }
  `}
`;

export const OneThirdWrapper = styled(Wrapper)`
  width: 33%;

  @media (max-width: 1010px) {
    width: 100%;
  }
`;

export const Table = styled.table`
  ${({ theme }) => css`
    margin: 3rem 0 0 0;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0 4px;
    background-color: ${theme.colors.lightGrey};
    box-shadow: 1px 1px 6px #ececec;
    border-radius: ${theme.radius.small};
  `}
`;

export const Thead = styled.thead`
  @media (max-width: 1010px) {
    display: none;
  }
`;

export const Tbody = styled.tbody`
  ${({ theme }) => css`
    background-color: ${theme.colors.backgroundContainer};
  `}
`;

export const Th = styled.th<IThProps>`
  ${({ width, textAlign }) => css`
    padding: 1.8rem 0 0 1rem;
    font-size: 14px;
    text-transform: uppercase;

    &:first-child {
      padding-left: 2rem;
    }

    ${width &&
    css`
      width: ${width};
    `}

    ${textAlign &&
    css`
      text-align: ${textAlign};
    `}
  `}
`;

export const TbodyTr = styled.tr`
  ${({ theme }) => css`
    transition: all 0.25s ease;
    background-color: #fff;

    &:hover {
      transform: translateY(-1px);
      background-color: ${theme.colors.hoverTable};
      border-radius: ${theme.radius.small};
    }

    @media (max-width: 1010px) {
      display: block;
      margin-bottom: 2rem;
      border-radius: ${theme.radius.small};
    }
  `}
`;

export const Td = styled.td<ITdProps>`
  ${({ theme, width, textAlign, padding, display, heading }) => css`
    border: 0;
    font-size: ${theme.fontSizes.meddium};
    padding: 1rem 0 0.5rem 1rem;
    font-weight: ${theme.weight.default};

    &:first-child {
      padding-left: 2rem;

      &::before {
        border-top-left-radius: ${theme.radius.small};
      }
    }

    &:last-child {
      padding-right: 2rem;

      &::before {
        border-bottom-left-radius: ${theme.radius.small};
      }
    }

    ${width &&
    css`
      width: ${width};
    `}

    ${textAlign &&
    css`
      text-align: ${textAlign};
    `}

    ${padding &&
    css`
      padding: ${padding};
    `}

    ${display &&
    css`
      display: ${display};
    `}

    @media (max-width: 1010px) {
      display: block;
      position: relative;
      width: 100%;
      padding-left: 14.2rem;
      text-align: left;

      &:first-child {
        padding-left: 14.2rem;
      }

      ${display &&
      css`
        display: ${display};
      `}

      &::before {
        ${heading &&
        css`
          content: '${heading}';
        `}

        width: 12rem;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        position: absolute;
        background-color: ${theme.colors.lightGrey};
        padding: 0 0.8rem;
        font-size: 14px;
        font-weight: 700;
      }
    }
  `}
`;

export const ButtonsContent = styled.div`
  display: flex;
  margin-top: 2rem;
`;
